"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnFormatter = void 0;
class ColumnFormatter {
  constructor(parserOptions) {
    if (parserOptions.trim) {
      this.format = col => col.trim();
    } else if (parserOptions.ltrim) {
      this.format = col => col.trimLeft();
    } else if (parserOptions.rtrim) {
      this.format = col => col.trimRight();
    } else {
      this.format = col => col;
    }
  }
}
exports.ColumnFormatter = ColumnFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDb2x1bW5Gb3JtYXR0ZXIiLCJjb25zdHJ1Y3RvciIsInBhcnNlck9wdGlvbnMiLCJ0cmltIiwiZm9ybWF0IiwiY29sIiwibHRyaW0iLCJ0cmltTGVmdCIsInJ0cmltIiwidHJpbVJpZ2h0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wYXJzZXIvY29sdW1uL0NvbHVtbkZvcm1hdHRlci50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBRUEsTUFBYUEsZUFBZTtFQUd4QkMsWUFBbUJDLGFBQTRCO0lBQzNDLElBQUlBLGFBQWEsQ0FBQ0MsSUFBSSxFQUFFO01BQ3BCLElBQUksQ0FBQ0MsTUFBTSxHQUFJQyxHQUFXLElBQWFBLEdBQUcsQ0FBQ0YsSUFBSSxFQUFFO0tBQ3BELE1BQU0sSUFBSUQsYUFBYSxDQUFDSSxLQUFLLEVBQUU7TUFDNUIsSUFBSSxDQUFDRixNQUFNLEdBQUlDLEdBQVcsSUFBYUEsR0FBRyxDQUFDRSxRQUFRLEVBQUU7S0FDeEQsTUFBTSxJQUFJTCxhQUFhLENBQUNNLEtBQUssRUFBRTtNQUM1QixJQUFJLENBQUNKLE1BQU0sR0FBSUMsR0FBVyxJQUFhQSxHQUFHLENBQUNJLFNBQVMsRUFBRTtLQUN6RCxNQUFNO01BQ0gsSUFBSSxDQUFDTCxNQUFNLEdBQUlDLEdBQVcsSUFBYUEsR0FBRzs7RUFFbEQ7O0FBYkpLLE9BQUEsQ0FBQVYsZUFBQSxHQUFBQSxlQUFBIn0=